export const groupByKey = (array, key) => {
  return array.reduce((obj, array) => {
    if (!array || array.length === 0) return obj
    const instanceKey = array[0][key]
    if (!Object.prototype.hasOwnProperty.call(obj, instanceKey)) {
      obj[instanceKey] = []
    }
    obj[instanceKey] = obj[instanceKey].concat(array)
    return obj
  }, {})
}
